
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { CryptoService } from './crypto.service';

@Injectable({
  providedIn: 'root',
})
export class UnsubapiService {
  private http = inject(HttpClient);
  private crypto = inject(CryptoService);

  //private baseRoute = 'https://localhost:7251/api/';
   private baseRoute = 'https://gildeddev.lessonplay.win/api/';
  // private baseRoute = 'https://api.Luckycrest.game/api/';

  /**
   * Reusable Helper to generate headers with Dynamic Crypto Security & Token
   */
  private getHeaders(payload: any, useToken: boolean): HttpHeaders {
    // 1. Generate security headers matching key rotation logic
    const cryptoHeaders = this.crypto.generateSecurityHeaders(payload);

    let headerConfig: { [key: string]: string } = {
      'Content-Type': 'application/json',
      ...cryptoHeaders 
    };

    // 2. Fetch auth token if route is protected
    if (useToken) {
      const token = localStorage.getItem('token');
      if (token) {
        headerConfig['Authorization'] = `Bearer ${token}`;
      }
    }

    return new HttpHeaders(headerConfig);
  }

  /**
   * Error Handler
   */
  public handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  /* ==========================================
      POST CALLS
     ========================================== */
  PostCallWithoutToken(Payload: any, apiroute: string): Observable<any> {
    const headers = this.getHeaders(Payload, false);
    return this.http
      .post<any>(`${this.baseRoute}${apiroute}`, Payload, { headers })
      .pipe(catchError(this.handleError));
  }

  PostCallWithToken(Payload: any, apiroute: string): Observable<any> {
    const headers = this.getHeaders(Payload, true);
    return this.http
      .post<any>(`${this.baseRoute}${apiroute}`, Payload, { headers })
      .pipe(catchError(this.handleError));
  }

  /* ==========================================
      GET CALLS
     ========================================== */
  GetCallWithoutToken(apiroute: string): Observable<any> {
    // Pass null payload to reflect empty request body matching .NET's read stream
    const headers = this.getHeaders(null, false);
    return this.http
      .get<any>(`${this.baseRoute}${apiroute}`, { headers })
      .pipe(catchError(this.handleError));
  }

  GetCallWithToken(apiroute: string): Observable<any> {
    const headers = this.getHeaders(null, true);
    return this.http
      .get<any>(`${this.baseRoute}${apiroute}`, { headers })
      .pipe(catchError(this.handleError));
  }

  /* ==========================================
      DELETE CALLS
     ========================================== */
  DeleteCallWithToken(apiroute: string): Observable<any> {
    const headers = this.getHeaders(null, true);
    return this.http
      .delete<any>(`${this.baseRoute}${apiroute}`, { headers })
      .pipe(catchError(this.handleError), shareReplay());
  }
}